import FullPageLoader from 'components/common/FullPageLoader';
import { Select } from 'components/common/Select';
import { TimeInput } from 'components/template/TemplateForm';
import React from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import Api from 'services/api';

const show = (value) => value !== null && value !== undefined && value !== '' && value !== 'N/A';

const EditPdfForm = ({
    data,
    invoiceNumber,
    loader,
    formState,
    updateAppointmentField,
    languages = [],
    facilities = [],
    totalBill = 0,
    appointmentTypeOptions = [],
    modalityOptions = [],
    commentOptions = [],
    control,
    clientId,
}) => {
    const clientData = data?.client || data;

    const filteredLanguagesLoadOptions = async (inputValue, loadedOptions, { page }) => {
        try {
            const response = await Api.fetchLanguages(page, {
                pageLength: 20,
                sortBy: 'id',
                sortDirection: 'asc',
                search: inputValue,
            });
            const result = response?.data?.data;
            const data = Array.isArray(result?.data) ? result.data : [];
            const lastPage = result?.last_page;

            return {
                options: data.map((language) => ({ label: language.name, value: language.id })),
                hasMore: page !== lastPage,
                additional: { page: page + 1 },
            };
        } catch (error) {
            console.error(error);
            return { options: [], hasMore: false, additional: { page } };
        }
    };

    const filteredFacilitiesLoadOptions = async (inputValue, loadedOptions, { page }) => {
        try {
            let response = null;

            if (clientId) {
                response = await Api.fetchFacilitiesByTypeId(clientId);
            }

            if (!response || response?.status >= 400) {
                response = await Api.fetchFacilities(page, {
                    pageLength: 20,
                    sortBy: 'id',
                    sortDirection: 'asc',
                    search: inputValue,
                });
            }

            const list = Array.isArray(response?.data?.data)
                ? response.data.data
                : Array.isArray(response?.data)
                    ? response.data
                    : [];

            const filtered = inputValue
                ? list.filter((facility) =>
                    (facility.facility_name || '').toLowerCase().includes(inputValue.toLowerCase())
                )
                : list;

            return {
                options: filtered.map((facility) => ({ label: facility.facility_name, value: facility.id })),
                hasMore: false,
                additional: { page: page + 1 },
            };
        } catch (error) {
            console.error(error);
            return { options: [], hasMore: false, additional: { page } };
        }
    };
    return (
        <>
            <div className="page">
                <header>
                    <div className="us">
                        <img src="/main-logo.png" alt="Logo" />
                    </div>
                    <div className="d-flex align-items-center">
                        {show(data?.invoice_number || invoiceNumber) && (
                            <div className="title">
                                <h4>INVOICE # {data?.invoice_number || invoiceNumber}</h4>
                            </div>
                        )}
                        <div className="title">
                            <h4>
                                Date: {data?.billing_date
                                    ? new Date(data.billing_date).toLocaleDateString('en-GB')
                                    : new Date().toLocaleDateString('en-GB')}
                            </h4>
                        </div>
                    </div>
                </header>

                <section>
                    <div className="billed-to">
                        <h1>Bill To</h1>
                        {show(clientData?.user?.name) && <h2>{clientData.user.name}</h2>}
                        {show(clientData?.billing_person) && <h3>{clientData.billing_person}</h3>}
                        {show(clientData?.billing_email) && <h3>{clientData.billing_email}</h3>}
                        {show(clientData?.billing_zipcode || clientData?.city?.name) && (
                            <h3>{clientData?.billing_zipcode} {clientData?.city?.name}</h3>
                        )}
                        {show(clientData?.state?.name) && <h3>{clientData.state.name}</h3>}
                    </div>

                    <div className="invoice-table-wrapper">
                        <table className="invoice-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Description</th>
                                    <th>Total Cost</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(formState?.appointments || []).map((appointment, index) => (
                                    <tr key={appointment.id || index}>
                                        <td>{index + 1}</td>
                                        <td>
                                            {show(appointment.appid) && (
                                                <div className="mb-2 font-bold" style={{ fontSize: '15px' }}>
                                                    <span>Appointment Number: {appointment.appid}</span>
                                                </div>
                                            )}

                                            <label className="d-flex align-items-center justify-content-start gap-2 mb-2">
                                                <div className="col-3">
                                                    <span>Language</span>
                                                </div>
                                                <div style={{ width: '100%' }}>
                                                    <AsyncPaginate
                                                        menuPlacement="auto"
                                                        styles={{ ...selectCustomStyles }}
                                                        value={
                                                            appointment.language_id
                                                                ? {
                                                                    value: appointment.language_id,
                                                                    label:
                                                                        appointment.languageName ||
                                                                        languages.find((language) => language.id === appointment.language_id)?.name ||
                                                                        '',
                                                                }
                                                                : null
                                                        }
                                                        loadOptions={filteredLanguagesLoadOptions}
                                                        isClearable={false}
                                                        escapeClearsValue
                                                        onChange={(obj) =>
                                                            updateAppointmentField(index, 'language_id', obj?.value, { languageName: obj?.label || '' })
                                                        }
                                                        additional={{ page: 1 }}
                                                    />
                                                </div>
                                            </label>

                                            <label className="row-primary d-flex align-items-center justify-content-start gap-2 mb-2">
                                                <div className="col-3">
                                                    <span>Date</span>
                                                </div>
                                                <div className="input-image" style={{ padding: '0px' }}>
                                                <input
                                                    className="input-in type_inp"
                                                    type="date"
                                                    value={appointment.scheduledDate || ''}
                                                    onChange={(event) => updateAppointmentField(index, 'scheduledDate', event.target.value)}
                                                />
                                                <img
                                                src="/images/celender.png"
                                                alt="celender Icon"
                                                className="custom-icon"
                                                />
                                                </div>
                                            </label>

                                            <label className="d-flex align-items-center justify-content-start gap-2 mb-2">
                                                <div className="col-3">
                                                    <span>Modality (Appt Type)</span>
                                                </div>
                                                <div style={{ width: '100%' }}>
                                                    <Select
                                                        name={`type_${index}`}
                                                        options={appointmentTypeOptions}
                                                        value={appointmentTypeOptions.find((option) => option.value === appointment.type) || null}
                                                        isClearable={false}
                                                        disabledSearch={true}
                                                        onChange={(value) => updateAppointmentField(index, 'type', value)}
                                                    />
                                                </div>
                                            </label>

                                            <label className="d-flex align-items-center justify-content-start gap-2 mb-2">
                                                <div className="col-3">
                                                    <span>Type (Subject)</span>
                                                </div>
                                                <div style={{ width: '100%' }}>
                                                    <Select
                                                        name={`subject_${index}`}
                                                        options={modalityOptions}
                                                        value={modalityOptions.find((option) => option.value === appointment.subject) || null}
                                                        isClearable={false}
                                                        disabledSearch={true}
                                                        onChange={(value) => updateAppointmentField(index, 'subject', value)}
                                                    />
                                                </div>
                                            </label>

                                            <label className="d-flex align-items-center justify-content-start gap-2 mb-2">
                                                <div className="col-3">
                                                    <span>Scheduled Start Time</span>
                                                </div>
                                                <TimeInput
                                                    name={`appointment_${index}_scheduledStartTime`}
                                                    control={control}
                                                    rule={false}
                                                    onChange={(value) => updateAppointmentField(index, 'scheduledStartTime', value)}
                                                />
                                            </label>

                                            <label className="row-primary d-flex align-items-center justify-content-start gap-2 mb-2">
                                                <div className="col-3">
                                                    <span>Scheduled Duration</span>
                                                </div>
                                                <input
                                                    className="input-in type_inp"
                                                    type="number"
                                                    min="0"
                                                    value={appointment.scheduledDuration || ''}
                                                    onChange={(event) => updateAppointmentField(index, 'scheduledDuration', event.target.value)}
                                                />
                                            </label>

                                            <label className="d-flex align-items-center justify-content-start gap-2 mb-2">
                                                <div className="col-3">
                                                    <span>Duration Unit</span>
                                                </div>
                                                <div style={{ width: '100%' }}>
                                                    <Select
                                                        name={`duration_unit_${index}`}
                                                        options={[{ label: 'Minute', value: 'minute' }, { label: 'Hour', value: 'hour' }]}
                                                        value={[{ label: 'Minute', value: 'minute' }, { label: 'Hour', value: 'hour' }].find((option) => option.value === (appointment.scheduledDurationUnit || 'minute')) || null}
                                                        isClearable={false}
                                                        disabledSearch={true}
                                                        onChange={(value) => updateAppointmentField(index, 'scheduledDurationUnit', value)}
                                                    />
                                                </div>
                                            </label>

                                            <label className="row-primary d-flex align-items-center justify-content-start gap-2 mb-2">
                                                <div className="col-3">
                                                    <span>Scheduled End Time</span>
                                                </div>
                                                <input className="input-in type_inp" type="time" value={appointment.scheduledEndTime || ''} readOnly />
                                            </label>

                                            <label className="d-flex align-items-center justify-content-start gap-2 mb-2">
                                                <div className="col-3">
                                                    <span>Actual Start Time</span>
                                                </div>
                                                <TimeInput
                                                    name={`appointment_${index}_actualStartTime`}
                                                    control={control}
                                                    rule={false}
                                                    onChange={(value) => updateAppointmentField(index, 'actualStartTime', value)}
                                                />
                                            </label>

                                            <label className="row-primary d-flex align-items-center justify-content-start gap-2 mb-2">
                                                <div className="col-3">
                                                    <span>Actual Duration (mins)</span>
                                                </div>
                                                <input
                                                    className="input-in type_inp"
                                                    type="number"
                                                    min="0"
                                                    value={appointment.actualDurationMinutes || ''}
                                                    onChange={(event) => updateAppointmentField(index, 'actualDurationMinutes', event.target.value)}
                                                />
                                            </label>

                                            <label className="row-primary d-flex align-items-center justify-content-start gap-2 mb-2">
                                                <div className="col-3">
                                                    <span>Actual End Time</span>
                                                </div>
                                                <input className="input-in type_inp" type="time" value={appointment.actualEndTime || ''} readOnly />
                                            </label>

                                            <label className="row-primary d-flex align-items-center justify-content-start gap-2 mb-2">
                                                <div className="col-3">
                                                    <span>Total Billable Duration (mins)</span>
                                                </div>
                                                <input className="input-in type_inp" type="number" value={appointment.totalBillableDuration || ''} readOnly />
                                            </label>

                                            <label className="d-flex align-items-center justify-content-start gap-2 mb-2">
                                                <div className="col-3">
                                                    <span>Facility Name</span>
                                                </div>
                                                <div style={{ width: '100%' }}>
                                                    <AsyncPaginate
                                                        menuPlacement="auto"
                                                        styles={{ ...selectCustomStyles }}
                                                        value={
                                                            appointment.facility_id
                                                                ? {
                                                                    value: appointment.facility_id,
                                                                    label:
                                                                        appointment.facilityName ||
                                                                        facilities.find((facility) => facility.id === appointment.facility_id)?.facility_name ||
                                                                        '',
                                                                }
                                                                : null
                                                        }
                                                        loadOptions={filteredFacilitiesLoadOptions}
                                                        isClearable={false}
                                                        escapeClearsValue
                                                        onChange={(obj) =>
                                                            updateAppointmentField(index, 'facility_id', obj?.value, { facilityName: obj?.label || '' })
                                                        }
                                                        additional={{ page: 1 }}
                                                    />
                                                </div>
                                            </label>

                                            <label className="row-primary d-flex align-items-center justify-content-start gap-2 mb-2">
                                                <div className="col-3">
                                                    <span>Vendor ID</span>
                                                </div>
                                                <input className="input-in type_inp" value={appointment.interpreterCode || ''} readOnly />
                                            </label>

                                            <label className="d-flex align-items-center justify-content-start gap-2 mb-2">
                                                <div className="col-3">
                                                    <span>Comments</span>
                                                </div>
                                                <div style={{ width: '100%' }}>
                                                    <Select
                                                        name={`comments_${index}`}
                                                        options={commentOptions}
                                                        value={commentOptions.find((option) => option.value === appointment.comments) || null}
                                                        isClearable={false}
                                                        disabledSearch={true}
                                                        onChange={(value) => updateAppointmentField(index, 'comments', value)}
                                                    />
                                                </div>
                                            </label>

                                            <label className="row-primary d-flex align-items-center justify-content-start gap-2 mb-2">
                                                <div className="col-3">
                                                    <span>Requestor Name</span>
                                                </div>
                                                <input className="input-in type_inp" value={appointment.requesterName || ''} onChange={(event) => updateAppointmentField(index, 'requesterName', event.target.value)} />
                                            </label>
                                            <label className="row-primary d-flex align-items-center justify-content-start gap-2 mb-2">
                                                <div className="col-3">
                                                    <span>Requestor Email</span>
                                                </div>
                                                <input className="input-in type_inp" value={appointment.requesterEmail || ''} onChange={(event) => updateAppointmentField(index, 'requesterEmail', event.target.value)} />
                                            </label>
                                            <label className="row-primary d-flex align-items-center justify-content-start gap-2 mb-2">
                                                <div className="col-3">
                                                    <span>Requestor Phone</span>
                                                </div>
                                                <input className="input-in type_inp" value={appointment.requesterPhone || ''} onChange={(event) => updateAppointmentField(index, 'requesterPhone', event.target.value)} />
                                            </label>

                                            <div className="mt-3 pt-2 border-top">
                                                <h5 className="mb-2 font-bold text-gray-700">Cost Breakdown & Pricing</h5>
                                                <label className="row-primary d-flex align-items-center justify-content-start gap-2 mb-2">
                                                    <div className="col-3">
                                                        <span>Applied Rate ($)</span>
                                                    </div>
                                                    <input className="input-in type_inp" type="number" step="0.01" value={appointment.rate || ''} onChange={(event) => updateAppointmentField(index, 'rate', event.target.value)} />
                                                </label>
                                                <label className="d-flex align-items-center justify-content-start gap-2 mb-2">
                                                    <div className="col-3">
                                                        <span>Rate Unit</span>
                                                    </div>
                                                    <div style={{ width: '100%' }}>
                                                        <Select
                                                            name={`rate_unit_${index}`}
                                                            options={[{ label: 'Hour', value: 'hour' }, { label: 'Minute', value: 'minute' }]}
                                                            // value={[{ label: 'Hour', value: 'hour' }, { label: 'Minute', value: 'minute' }].find((option) => option.value === (appointment.rateUnit || 'hour')) || null}
                                                            value={{ label: 'Hour', value: 'hour' }}
                                                            isClearable={false}
                                                            disabledSearch={true}
                                                            onChange={(value) => updateAppointmentField(index, 'rateUnit', value)}
                                                            isDisabled={true}
                                                        />
                                                    </div>
                                                </label>
                                                <label className="row-primary d-flex align-items-center justify-content-start gap-2 mb-2">
                                                    <div className="col-3">
                                                        <span>Rush Fee ($)</span>
                                                    </div>
                                                    <input className="input-in type_inp" type="number" step="0.01" min="0" value={appointment.rushFee ?? ''} onChange={(event) => updateAppointmentField(index, 'rushFee', event.target.value)} />
                                                </label>
                                                <label className="row-primary d-flex align-items-center justify-content-start gap-2 mb-2">
                                                    <div className="col-3">
                                                        <span>Mileage ($)</span>
                                                    </div>
                                                    <input className="input-in type_inp" type="number" step="0.01" min="0" value={appointment.mileage ?? ''} onChange={(event) => updateAppointmentField(index, 'mileage', event.target.value)} />
                                                </label>
                                                <label className="row-primary d-flex align-items-center justify-content-start gap-2 mb-2">
                                                    <div className="col-3">
                                                        <span>Travel ($)</span>
                                                    </div>
                                                    <input className="input-in type_inp" type="number" step="0.01" min="0" value={appointment.travel ?? ''} onChange={(event) => updateAppointmentField(index, 'travel', event.target.value)} />
                                                </label>
                                                <label className="row-primary d-flex align-items-center justify-content-start gap-2 mb-2">
                                                    <div className="col-3">
                                                        <span>Discount (%)</span>
                                                    </div>
                                                    <input className="input-in type_inp" type="number" step="0.01" min="0" value={appointment.discount ?? ''} onChange={(event) => updateAppointmentField(index, 'discount', event.target.value)} />
                                                </label>
                                                <label className="row-primary d-flex align-items-center justify-content-start gap-2 mb-2">
                                                    <div className="col-3">
                                                        <span>Total Amount ($)</span>
                                                    </div>
                                                    <input className="input-in type_inp font-bold" type="number" step="0.01" value={Number(appointment.totalAmount || 0).toFixed(2)} readOnly />
                                                </label>
                                            </div>
                                        </td>
                                        <td className="font-bold text-end" style={{ verticalAlign: 'top', paddingTop: '15px' }}>
                                            ${Number(appointment.totalAmount || 0).toFixed(2)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <table className="info-container last_info">
                        <tbody>
                            <tr>
                                <th className="text-end last_due">Total Due</th>
                                <th className="text-end last_due">${totalBill}</th>
                            </tr>
                        </tbody>
                    </table>
                </section>
            </div>

            {loader && <FullPageLoader />}
        </>
    );
};

export default EditPdfForm;